import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "./index.less";
import "./configs/i18n";
import reportWebVitals from "./reportWebVitals";
import StoreProvider from "./stores";
import "core-js/stable";
import "regenerator-runtime/runtime";
import Loading from "./components/Loading";

const Views = lazy(() => import("./views"));

const rootElement = document.getElementById("root");

try {
    if (rootElement) {
        const root = ReactDOM.createRoot(rootElement);
        root.render(
            <StoreProvider>
                <Suspense fallback={<Loading />}>
                    <Views />
                </Suspense>
            </StoreProvider>
        );
    } else {
        console.error("Root element not found");
    }
} catch (error) {
    console.log(`Somethings wrong! ${error}`);
}

reportWebVitals();
